import { Component, HostBinding, Input, OnChanges, OnInit } from "@angular/core";
import { EBPMSService } from "../ebpms.service";
import { EBPMSStatus } from "../_models/EBPMSStatus";
import "./ebpms-status-icon.component.scss";

@Component({
    selector: 'ebpms-status-icon',
    template: require("./ebpms-status-icon.component.html")
})
export class EBPMSStatusIconComponent implements OnChanges, OnInit {
    @Input() ebpmsStatus: EBPMSStatus;
    @HostBinding("class") class: string;

    icon: string;

    constructor(private readonly ebpmsService: EBPMSService) {
    }

    ngOnInit(): void {
        this.ngOnChanges();
    }

    ngOnChanges(): void {
        switch (this.ebpmsStatus) {
            case EBPMSStatus.Good:
                this.class = "valid";
                break;

            case EBPMSStatus.Warning:
                this.class = "invalid";

            case EBPMSStatus.Unknown:
            default:
                this.class = "warning";
                break;
        }

        this.setIcon();
    }

    // ---

    private setIcon(): void {        
        this.icon = this.ebpmsService.getStatusIcon(this.ebpmsStatus);
    }
}
